import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
export const actionTypes = {
    Loading: "LOADING",
};

const initialGlobalState = {
    loading: false,
};

export const reducer = persistReducer(
    { storage, key: "invifo-global", whitelist: ["loading"] },
    (state = initialGlobalState, action) => {
        switch (action.type) {
            case actionTypes.Loading: {
                const { loading } = action.payload;
                return { loading };
            }
            default:
                return state;
        }
    }
);


export const actionsGlobal = {
    loading: loading => ({ type: actionTypes.Loading, payload: { loading } }),
};